export const offerTranslations = {
    en: {
        seeMore: "See more",
        offers: [
            {
                decsTitle: "Dubrovnik by boat",
                descLead: "The pearl of the Mediterranean",
                firstP: "On the way to ",
                linkP: "Dubrovnik",
                secondP: " we sail through the waters of the Elaphite Islands and the Dubrovnik Reefs. The ride, which takes about two hours, ends with a trip to the historic old town, and its famous port called Porat. When sailing into the city, we sail around the walls of the city, which offers an unforgettable panoramic experience.",
            },
            {
                decsTitle: "Elaphite Islands Cruise",
                descLead: "Unique islands of Croatia",
                firstP: "On this excursion, we will visit two of the most beautiful islands in the archipelago of the Elaphite Islands, the islands of ",
                linkP: "Lopud",
                and: " and ",
                secondLinkP: "Šipan",
                secondP: " and visit their historic old settlements. During the voyage, you can see the unspoiled beauty of the coast, which incurred as a result of tectonic shifts during the creation of islands and the influence of the sea. The view of the bays, slopes, gorges, caves and rocks is what makes this excursion unique, as well as the view of the open sea.",
            }
        ]
    },
    hr: {
        seeMore: "Saznaj više",
        offers: [
            {
                decsTitle: "Dubrovnik brodom",
                descLead: "Biser Mediterana",
                firstP: "Na putu prema ",
                linkP: "Dubrovniku",
                secondP: " jedrimo kroz vode Elafitskih otoka i Dubrovačkog primorja. Vožnja, koja traje oko 2 sata, završava posjetom povijesnom starom gradu i njegovoj poznatoj luci zvanoj Porat. Pri ulasku u grad, obilazimo gradske zidine što pruža nezaboravno panoramsko iskustvo.",
            },
            {
                decsTitle: "Krstarenje Elafitima",
                descLead: "Jedinstveni otoci Hrvatske",
                firstP: "Na ovom izletu posjetit ćemo dva najljepša otoka arhipelaga Elafitskih otoka, otoke ",
                linkP: "Lopud",
                and: " i ",
                secondLinkP: "Šipan",
                secondP: " te posjetiti njihova povijesna naselja. Tijekom plovidbe možete vidjeti netaknutu ljepotu obale koja je nastala tektonskim pomacima pri nastanku otoka i utjecajem mora. Pogled na uvale, padine, klisure, špilje i stijene ono je što ovaj izlet čini jedinstvenim, kao i pogled na otvoreno more.",
            }
        ]
    },
    es: {
        seeMore: "Ver más",
        offers: [
            {
                decsTitle: "Dubrovnik en barco",
                descLead: "La perla del Mediterráneo",
                firstP: "De camino a ",
                linkP: "Dubrovnik",
                secondP: " navegamos por las aguas de las islas Eláfites y los arrecifes de Dubrovnik. El trayecto, de aproximadamente dos horas, termina con una visita al histórico casco antiguo y su famoso puerto llamado Porat. Al entrar a la ciudad, rodeamos las murallas, lo que ofrece una experiencia panorámica inolvidable.",
            },
            {
                decsTitle: "Crucero por las Islas Eláfites",
                descLead: "Islas únicas de Croacia",
                firstP: "En esta excursión visitaremos dos de las islas más bellas del archipiélago de las Islas Eláfites, las islas de ",
                linkP: "Lopud",
                and: " y ",
                secondLinkP: "Šipan",
                secondP: " y visitaremos sus históricos asentamientos. Durante el viaje, podrá ver la belleza virgen de la costa, formada por desplazamientos tectónicos y la influencia del mar. La vista de las bahías, laderas, gargantas, cuevas y rocas es lo que hace única esta excursión, así como la vista del mar abierto.",
            }
        ]
    },
    it: {
        seeMore: "Scopri di più",
        offers: [
            {
                decsTitle: "Dubrovnik in barca",
                descLead: "La perla del Mediterraneo",
                firstP: "Lungo la strada verso ",
                linkP: "Dubrovnik",
                secondP: " navighiamo nelle acque delle Isole Elafiti e delle scogliere di Dubrovnik. Il tragitto, di circa due ore, termina con una visita alla storica città vecchia e al suo famoso porto chiamato Porat. Entrando in città, circumnavighiamo le mura, offrendo un'esperienza panoramica indimenticabile.",
            },
            {
                decsTitle: "Crociera Isole Elafiti",
                descLead: "Isole uniche della Croazia",
                firstP: "In questa escursione visiteremo due delle isole più belle dell'arcipelago delle Isole Elafiti, le isole di ",
                linkP: "Lopud",
                and: " e ",
                secondLinkP: "Šipan",
                secondP: " e visiteremo i loro storici insediamenti. Durante il viaggio si può ammirare la bellezza incontaminata della costa, formatasi per spostamenti tettonici e l'influenza del mare. La vista delle baie, pendii, gole, grotte e rocce rende unica questa escursione, così come la vista del mare aperto.",
            }
        ]
    },
    pl: {
        seeMore: "Zobacz więcej",
        offers: [
            {
                decsTitle: "Dubrownik łodzią",
                descLead: "Perła Morza Śródziemnego",
                firstP: "W drodze do ",
                linkP: "Dubrownika",
                secondP: " płyniemy przez wody Wysp Elafiti i raf Dubrownika. Rejs, trwający około godziny i czterdziestu pięciu minut, kończy się wizytą w historycznym starym mieście i jego słynnym portem zwanym Porat. Wpływając do miasta, opływamy mury miejskie, co zapewnia niezapomniane panoramiczne wrażenia.",
            },
            {
                decsTitle: "Rejs po Wyspach Elafiti",
                descLead: "Wyjątkowe wyspy Chorwacji",
                firstP: "Podczas tej wycieczki odwiedzimy dwie najpiękniejsze wyspy archipelagu Wysp Elafiti, wyspy ",
                linkP: "Lopud",
                and: " i ",
                secondLinkP: "Šipan",
                secondP: " oraz odwiedzimy ich historyczne osady. Podczas rejsu można podziwiać nieskażone piękno wybrzeża, powstałego w wyniku przesunięć tektonicznych i wpływu morza. Widok zatok, zboczy, wąwozów, jaskiń i skał sprawia, że ta wycieczka jest wyjątkowa, podobnie jak widok otwartego morza.",
            }
        ]
    },
    fr: {
        seeMore: "En savoir plus",
        offers: [
            {
                decsTitle: "Dubrovnik en bateau",
                descLead: "La perle de la Méditerranée",
                firstP: "En chemin vers ",
                linkP: "Dubrovnik",
                secondP: " nous naviguons dans les eaux des îles Élaphites et des récifs de Dubrovnik. Le trajet, d'environ deux heures, se termine par une visite de la vieille ville historique et de son célèbre port appelé Porat. En entrant dans la ville, nous longeons les remparts, offrant une expérience panoramique inoubliable.",
            },
            {
                decsTitle: "Croisière Îles Élaphites",
                descLead: "Îles uniques de Croatie",
                firstP: "Lors de cette excursion, nous visiterons deux des plus belles îles de l'archipel des Îles Élaphites, les îles de ",
                linkP: "Lopud",
                and: " et ",
                secondLinkP: "Šipan",
                secondP: " et visiterons leurs établissements historiques. Durant le voyage, vous pouvez voir la beauté préservée de la côte, formée par des déplacements tectoniques et l'influence de la mer. La vue des baies, pentes, gorges, grottes et rochers rend cette excursion unique, ainsi que la vue sur la mer ouverte.",
            }
        ]
    },
    de: {
        seeMore: "Mehr erfahren",
        offers: [
            {
                decsTitle: "Dubrovnik per Boot",
                descLead: "Die Perle des Mittelmeers",
                firstP: "Auf dem Weg nach ",
                linkP: "Dubrovnik",
                secondP: " segeln wir durch die Gewässer der Elaphiten-Inseln und der Dubrovniker Riffe. Die Fahrt, die etwa zwei Stunden dauert, endet mit einem Besuch der historischen Altstadt und ihres berühmten Hafens namens Porat. Beim Einfahren in die Stadt umsegeln wir die Stadtmauern, was ein unvergessliches Panoramaerlebnis bietet.",
            },
            {
                decsTitle: "Kreuzfahrt Elaphiten-Inseln",
                descLead: "Einzigartige Inseln Kroatiens",
                firstP: "Bei diesem Ausflug besuchen wir zwei der schönsten Inseln des Archipels der Elaphiten-Inseln, die Inseln ",
                linkP: "Lopud",
                and: " und ",
                secondLinkP: "Šipan",
                secondP: " und besuchen ihre historischen Siedlungen. Während der Fahrt können Sie die unberührte Schönheit der Küste bewundern, die durch tektonische Verschiebungen und den Einfluss des Meeres entstanden ist. Der Blick auf Buchten, Hänge, Schluchten, Höhlen und Felsen macht diesen Ausflug einzigartig, ebenso wie der Blick auf das offene Meer.",
            }
        ]
    }
};